import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import PharmaAndLabOrderService from "../Services/PharmaAndLabOrderService";

function LabReportLink() {
  const loadingIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;
  const [labList, setLabList] = useState([]);
  const [loading, setLoading] = useState(true);

  const getCodeFromURL = () => {
    const query = window.location.search;
    const codeMatch = query.match(/ref=([^&]*)/);
    return codeMatch ? codeMatch[1] : null;
  };

  useEffect(() => {
    const param = getCodeFromURL();
    setTimeout(() => {
      if (param) {
        getFiles();
      }
    }, 100);
  }, []);

  const getFiles = async () => {
    const param = getCodeFromURL();
    try {
      if (param) {
        let payload = {
          labTestOrderId: param,
          status: 1,
        };
        let result = await PharmaAndLabOrderService.LabListGet(payload);
        if (result && result.data && result.data.length > 0) {
          setLabList(result.data);
        }

      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      {loading ? (
        <div>
          <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <Spin indicator={loadingIcon} size="large" />
          </div>
        </div>
      ) : (
        <div className="m-4 border rounded-md p-2">
          {labList && labList.length > 0 ? (
            labList.map((item) => (
              <div key={item.id}>
                <div className="m-4 p-2 border-b flex gap-2">
                  <div>
                    <div>
                      <span className="font-bold">Patient Name:</span>{" "}
                      {item.patientName}
                    </div>
                    <div>
                      <span className="font-bold">Report Name:</span>{" "}
                      {item.labTestName}
                    </div>
                  </div>
                </div>

                <embed
                  src={`${
                    process.env.REACT_APP_IMAGE_URL + item?.resultDocumentName
                  }#zoom=150`}
                  type="application/pdf"
                  className="w-full h-screen m-4"
                />
              </div>
            ))
          ) : (
            <div className="flex items-center justify-center h-40 text-gray-500 text-lg">
              No data available
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default LabReportLink;
